<template>
  <el-card :body-style="{ padding: '32px 24px 70px' }">
    <div class="warning-header">
      <div class="warning-title">
        <span>PayPal账户预警</span>
        <el-switch :value="form.status ? true : false" @change="changeStatus"></el-switch>
      </div>
      <div class="warning-tip">当PayPal账户满足以下条件时，将标记为预警账户，系统将提醒您留意风控风险</div>
    </div>
    <template v-if="form.status">
      <div class="condition-list">
        <el-form inline :model="form" ref="paypalWarningList">
          <div class="condition-item" v-for="(item, index) in form.paypalWarningList" :key="index">
            <div class="condition-header">
              <span>预警条件{{ index + 1 }}</span>
              <i
                v-show="form.paypalWarningList.length > 1"
                @click="removeCondition(index)"
                class="iconfont-el icon-a-18guanbi1"
                style="cursor: pointer"
              ></i>
            </div>
            <div class="condition-content">
              <div class="condition-title">
                <div>如果符合下列</div>
                <el-select v-model="item.type" style="width: 100px; margin: 0 12px">
                  <el-option v-for="(f, fIndex) in fConfig" :key="fIndex" :label="f.label" :value="f.value"></el-option>
                </el-select>
                <div>条件：</div>
              </div>
              <div class="condition-rule">
                <template v-for="(condition, cIndex) in item.paypalWarningItemList">
                  <div :key="cIndex" class="condition-rule-item">
                    <el-form-item>
                      <el-select
                        style="width: 160px"
                        v-model="condition.columnType"
                        @change="val => setRuleList(val, index, cIndex)"
                      >
                        <el-option
                          v-for="(f, fIndex) in conditionList"
                          :key="fIndex"
                          :label="f.label"
                          :value="f.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select style="width: 160px" v-model="condition.matchRule" :disabled="!condition.columnType">
                        <el-option
                          v-for="(f, fIndex) in getRuleList(condition.columnType)"
                          :key="fIndex"
                          :label="f.label"
                          :value="f.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      :prop="'paypalWarningList.' + index + '.paypalWarningItemList.' + cIndex + '.columnValue'"
                      :rules="inputRule"
                      :ref="'columnValue' + index + cIndex"
                    >
                      <el-select
                        v-model="condition.columnValue"
                        v-if="![2, 3, 4].includes(condition.columnType)"
                        :disabled="!condition.matchRule"
                        filterable
                        style="max-width: 400px; min-width: 280px"
                      >
                        <el-option
                          v-for="(f, fIndex) in getValueList(condition.columnType)"
                          :key="fIndex"
                          :label="f.label"
                          :value="f.value"
                        ></el-option>
                      </el-select>
                      <el-input
                        style="max-width: 400px; min-width: 280px"
                        v-model.trim="condition.columnValue"
                        v-else
                        :disabled="!condition.matchRule"
                      ></el-input>
                    </el-form-item>
                    <i
                      class="iconfont icona-19yichu"
                      v-show="item.paypalWarningItemList.length != 1"
                      @click="removeRule(index, cIndex)"
                    ></i>
                    <i
                      class="iconfont icona-20tianjia"
                      v-show="item.paypalWarningItemList.length == cIndex + 1"
                      @click="addRule(index)"
                    ></i>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <el-button type="text" @click="addCondition">
            <i class="iconfont-el icon-a-12tianjia2"></i>
            添加条件
          </el-button>
        </el-form>
      </div>
      <div class="warning-notice">
        <div class="notice-title">预警通知</div>
        <div class="notice-tip">推送对象：全部含「PayPal风控中心」查看权限的用户</div>
        <el-checkbox-group v-model="form.pushTypes">
          <el-checkbox :label="1">系统消息</el-checkbox>
          <el-checkbox :label="2">微信公众号提醒</el-checkbox>
          <el-tooltip placement="top">
            <span slot="content">
              公众号接收预警信息需关注并绑定shoplus微信公众号，请使用微信关注“超店Shoplus”并绑定您的账号
            </span>
            <i class="iconquestion-circle-o iconfont" style="font-size: 14px; margin-left: 6px"></i>
          </el-tooltip>
        </el-checkbox-group>
      </div>
    </template>
    <div class="hanlde-footer">
      <el-button style="text-align: end" @click="reset">
        {{ $t('system::common::btn::reset') }}
      </el-button>
      <el-button type="primary" style="margin-right: 16px" @click="sumbit">
        {{ $t('system::common::btn::save') }}
      </el-button>
    </div>
  </el-card>
</template>

<script>
import { getPaypalQueryList, getPaypalWarningSetting, updatePaypalWarningSetting } from '@/server/paypal'
export default {
  data() {
    let validValue = (rule, value, callback) => {
      let str = rule.field.split('.')
      console.log(this.form.paypalWarningList[str[1]].paypalWarningItemList[str[3]].columnType)
      if (!value) {
        callback(new Error('请输入条件值'))
      } else if ([2, 3, 4].includes(this.form.paypalWarningList[str[1]].paypalWarningItemList[str[3]].columnType)) {
        if (isNaN(Number(value))) {
          callback(new Error('请输入数字'))
        } else if (!/^-?\d+\.?\d{0,2}$/.test(value)) {
          callback(new Error('请输入两位小数'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      form: {
        status: 0,
        pushTypes: [1], // 默认推送系统消息
        paypalWarningList: [
          {
            type: 1,
            paypalWarningItemList: [{ columnType: '', matchRule: '', columnValue: '' }],
          },
        ],
      },
      fConfig: [
        { label: '全部', value: 1 },
        { label: '任一', value: 2 },
      ],
      conditionList: [
        { label: 'PayPal账户', value: 1 },
        { label: '总余额', value: 2 },
        { label: '可提现余额', value: 3 },
        { label: '冻结余额', value: 4 },
        { label: '所属店铺', value: 5 },
        { label: '公司名称', value: 6 },
        { label: '客户经理', value: 7 },
        { label: '状态', value: 8 },
      ],
      ruleList: [],
      valueList: [],
      paypalList: [],
      managerList: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      statusList: [
        { label: '正常', value: '1' },
        { label: '不可收款', value: '4' },
      ],
      companyList: [],
      inputRule: [{ validator: validValue, trigger: 'blur' }],
    }
  },
  mounted() {
    this.getPaypalQueryList()
    this.getPaypalWarningSetting()
  },
  computed: {
    shopList() {
      return this.$store.state.products.shopList.map(el => {
        return { label: el.label, value: String(el.value) }
      })
    },
  },
  methods: {
    changeStatus(val) {
      this.form.status = val ? 1 : 0
    },
    async getPaypalQueryList() {
      let { data } = await getPaypalQueryList()
      if (data.code === this.$code) {
        this.companyList = (data.data.companyNames || []).map(el => {
          return { label: el, value: el }
        })
        this.paypalList = (data.data.accounts || []).map(el => {
          return { label: el.name, value: String(el.id) }
        })
      }
    },
    async getPaypalWarningSetting() {
      let { data } = await getPaypalWarningSetting()
      if (data.code === this.$code) {
        this.form.status = data.data.status
        this.form.pushTypes = data.data.pushTypes || [1] // 为null时为初始化状态
        if (data.data.paypalWarningList && data.data.paypalWarningList.length) {
          this.form.paypalWarningList = data.data.paypalWarningList
        }
      }
    },
    setRuleList(val, index, cIndex) {
      this.form.paypalWarningList[index].paypalWarningItemList[cIndex].matchRule = ''
      this.form.paypalWarningList[index].paypalWarningItemList[cIndex].columnValue = ''
      this.$refs[`columnValue${index}${cIndex}`][0].clearValidate()
    },
    getRuleList(val) {
      if (val == 2 || val == 3 || val == 4) {
        return [
          { label: '=', value: '=' },
          { label: '>', value: '&gt;' },
          { label: '<', value: '&lt;' },
          { label: '≥', value: '&gt;=' },
          { label: '≤', value: '&lt;=' },
        ]
      } else {
        return [
          { label: '为', value: '=' },
          { label: '不为', value: '!=' },
        ]
      }
    },
    getValueList(val) {
      switch (val) {
        case 1:
          return this.paypalList
        case 5:
          return this.shopList
        case 6:
          return this.companyList
        case 7:
          return this.managerList
        case 8:
          return this.statusList
        default:
          return []
      }
    },
    // 新增条件
    addCondition() {
      this.form.paypalWarningList.push({
        type: 1,
        paypalWarningItemList: [{ columnType: '', matchRule: '', columnValue: '' }],
      })
    },
    removeCondition(index) {
      // 移除时需要清除校验
      for (let i = 0; i < this.form.paypalWarningList[index].paypalWarningItemList.length; i++) {
        this.$refs[`columnValue${index}${i}`][0].clearValidate()
      }
      this.form.paypalWarningList.splice(index, 1)
    },
    // 新增规则
    addRule(index) {
      this.form.paypalWarningList[index].paypalWarningItemList.push({ columnType: '', matchRule: '', columnValue: '' })
    },
    removeRule(index, cIndex) {
      this.$refs[`columnValue${index}${cIndex}`][0].clearValidate()
      this.form.paypalWarningList[index].paypalWarningItemList.splice(cIndex, 1)
    },
    async updatePaypalWarningSetting() {
      let { data } = await updatePaypalWarningSetting(this.form)
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.getPaypalWarningSetting()
      }
    },
    sumbit() {
      // 判断是否开启，开启时需判断表单内容
      if (!this.form.status) {
        this.updatePaypalWarningSetting()
      } else {
        this.$refs.paypalWarningList.validate(val => {
          if (val) {
            this.updatePaypalWarningSetting()
          }
        })
      }
    },
    reset() {
      this.form = {
        ...this.form,
        ...{
          status: 1,
          pushTypes: [1],
          paypalWarningList: [
            {
              type: 1,
              paypalWarningItemList: [{ columnType: '', matchRule: '', columnValue: '' }],
            },
          ],
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.warning-header {
  margin-bottom: 32px;
  .warning-title {
    font-size: 16px;
    font-weight: 600;
    color: #010517;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 40%;
  }
  .warning-tip {
    font-size: 12px;
    margin-top: 12px;
    color: #999;
  }
}
.condition-list {
  border-top: 1px solid #f2f3f5;
  border-bottom: 1px solid #f2f3f5;
  padding: 24px 0;
  .condition-item {
    border-radius: 8px;
    background: #f8f9fa;
    .condition-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 24px;
      color: #010517;
      i {
        color: #999;
      }
      border-bottom: 1px solid #e7e7e7;
    }
    .condition-content {
      padding: 24px;
      .condition-title {
        color: #010517;
        display: flex;
        align-items: center;
      }
      .condition-rule-item {
        margin-top: 16px;
        display: flex;
        align-items: center;
        .icona-20tianjia {
          color: #005af6;
          font-size: 20px;
          cursor: pointer;
        }
        .icona-19yichu {
          color: #ff2315;
          font-size: 20px;
          margin-right: 16px;
          cursor: pointer;
        }
        /deep/ .el-form-item {
          margin-bottom: 0;
          margin-right: 16px;
        }
      }
    }
  }
  .condition-item + .condition-item {
    margin-top: 16px;
  }
}
.warning-notice {
  padding: 32px 0;
  .notice-title {
    color: #010517;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .notice-tip {
    font-size: 12px;
    margin-top: 12px;
    color: #999;
    margin-bottom: 32px;
  }
}
.hanlde-footer {
  border-top: 1px solid #f2f3f5;
  padding-top: 16px;
  text-align: end;
  position: absolute;
  bottom: 16px;
  width: 100%;
  left: 0;
}
</style>
